// Horse goals card. Mirrors data-component="horse-goals" from the
// approved HTML. Two columns: Why this product (customer's words) and
// What success looks like (customer's goal).
//
// TODO(runtime): hydrate from services/horse-timeline summarize call
// goals block (proposed - TODO runtime).
import type { ReactNode } from 'react';
import type { HorseProfile, EditorMode } from '../mockData.js';

export interface HorseGoalsProps {
  horse: HorseProfile;
  onEdit: (mode: EditorMode) => void;
  /** W32: real first name on a real session. Defaults to the design-preview customer. */
  customerFirstName?: string;
}

export function HorseGoals({ horse, onEdit, customerFirstName = 'Sarah' }: HorseGoalsProps): ReactNode {
  return (
    <section className="card" data-component="horse-goals">
      <div className="card-head">
        <h3>What matters to {customerFirstName}</h3>
        <button className="text-btn" type="button" onClick={() => onEdit('goals')}>
          Edit notes
        </button>
      </div>
      <div className="goals-grid">
        <div>
          <span className="eyebrow">WHY THIS PRODUCT</span>
          <p>{horse.goals.reason}</p>
          <small>Capture {customerFirstName}'s own words.</small>
        </div>
        <div>
          <span className="eyebrow">WHAT SUCCESS LOOKS LIKE</span>
          <p>{horse.goals.goal}</p>
          <small>A clear goal makes the next conversation personal.</small>
        </div>
      </div>
    </section>
  );
}
